import { motion } from "motion/react";

export default function TermsPage() {
  return (
    <main className="w-full bg-transparent relative overflow-x-hidden pt-28 pb-24 z-10">
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-Montserrat text-xs tracking-widest uppercase text-indigo-600 dark:text-indigo-300/70 mb-6 flex items-center gap-4"
        >
          <div className="w-4 h-px bg-indigo-500/50" />
          Legal
        </motion.div>

        <motion.h1
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
          className="font-Montserrat text-5xl md:text-7xl font-bold tracking-tight mb-12 text-black dark:text-white"
        >
          Terms of Service
        </motion.h1>

        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className="max-w-3xl font-Montserrat text-base text-black/70 dark:text-white/70 leading-relaxed space-y-6"
        >
          <p>
            Welcome to KIVAS Tech. By accessing or using our website and
            services, you agree to be bound by these Terms of Service. If you do
            not agree, please do not use our services.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Services
          </h2>
          <p>
            KIVAS Tech provides 3D animation, AR/VR/XR experiences, AI-powered
            systems, software solutions, and hardware integration services. All
            services are subject to the terms agreed upon in our service
            agreements.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Intellectual Property
          </h2>
          <p>
            All content, trademarks, and intellectual property on this website
            are owned by or licensed to KIVAS Tech. You may not reproduce,
            distribute, or create derivative works without our prior written
            consent.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Limitation of Liability
          </h2>
          <p>
            KIVAS Tech shall not be liable for any indirect, incidental, or
            consequential damages arising from your use of our website or
            services.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Changes to Terms
          </h2>
          <p>
            We reserve the right to modify these terms at any time. Changes will
            be effective immediately upon posting to this page.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Contact
          </h2>
          <p>
            For questions about these terms, contact us at{" "}
            <a
              href="mailto:info@kivastech.com"
              className="text-indigo-500 hover:text-indigo-400 transition-colors"
            >
              info@kivastech.com
            </a>
            .
          </p>

          <p className="text-sm text-black/40 dark:text-white/40 pt-6">
            Last updated: June 2026
          </p>
        </motion.div>
      </div>
    </main>
  );
}
